export default "__VITE_ASSET__D87UxH5O__"